const it = {
  brand: "E2 Care",
  tagline: "Assistenza calma e connessa.",
  nav_dashboard: "Dashboard",
  nav_residents: "Pazienti",
  nav_patients: "Pazienti",
  nav_rooms: "Stanze",
  nav_devices: "Dispositivi",
  nav_events: "Eventi",
  nav_alerts: "Avvisi",
  nav_users: "Team",
  nav_settings: "Impostazioni",
  nav_admin: "Amministrazione",
  nav_signout: "Esci",
  topbar_search_placeholder: "Cerca pazienti, stanze, dispositivi…",
  admin_super_only: "Solo i super-amministratori possono gestire le organizzazioni.",
  admin_admin_only: "Solo gli amministratori possono accedere a questa pagina.",
  admin_tab_orgs: "Organizzazioni",
  admin_tab_users: "Utenti",
  admin_tab_patients: "Pazienti",
  admin_tab_rooms: "Stanze",
  admin_tab_buildings: "Edifici",
  admin_tab_devices: "Dispositivi",
  admin_tab_alerts: "Avvisi",
  admin_tab_qa: "Strumenti di test",
  admin_delete: "Elimina",
  admin_no_orgs_yet: "Ancora nessuna organizzazione.",
  admin_field_name: "Nome",
  admin_field_email: "E-mail",
  admin_field_phone: "Telefono",
  admin_field_password: "Password",
  admin_field_role: "Ruolo",
  admin_field_type: "Tipo",
  admin_field_timezone: "Fuso orario",
  admin_field_address: "Indirizzo",
  admin_field_status: "Stato",
  admin_field_organization: "Organizzazione",
  admin_password_keep: "Lascia vuoto per mantenere",
  admin_field_birth_date: "Data di nascita",
  admin_field_room: "Stanza",
  admin_field_room_none: "Non assegnato",
  admin_field_photo: "URL foto",
  admin_field_photo_hint: "Incolla un URL pubblico — caricamento completo in v2.",
  admin_field_notes: "Note del caregiver",
  admin_field_emergency_contact: "Contatto di emergenza principale",
  admin_field_ec_name: "Nome",
  admin_field_ec_phone: "Telefono",
  admin_field_ec_relationship: "Relazione",
  admin_field_mac: "Indirizzo MAC",
  admin_field_firmware: "Firmware",
  admin_field_assignment: "Assegnato a",
  admin_field_assigned_room: "Stanza assegnata",
  admin_field_assigned_patient: "Paziente assegnato",
  admin_field_assigned_hint: "Opzionale. Sensori → stanza; braccialetti → paziente.",
  admin_field_sensor_target: "Montato su",
  admin_field_sensor_target_hint: "Indica al sistema se questo sensore controlla una porta o una finestra.",
  sensor_target_door: "Porta",
  sensor_target_window: "Finestra",
  sensor_target_unset: "Non configurato",
  admin_field_sensor_label: "Etichetta sensore",
  admin_field_sensor_label_hint: "Nome descrittivo mostrato in avvisi ed eventi — es. «Porta d’ingresso», «Finestra del bagno».",
  admin_field_building: "Edificio",
  admin_field_building_required: "Una stanza deve appartenere a un edificio.",
  room_openings: "Aperture",
  room_no_openings: "Nessun sensore di porta o finestra installato in questa stanza.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Ultima variazione",
  admin_field_description: "Descrizione",
  admin_field_severity: "Gravità",
  admin_field_patient: "Paziente",
  admin_field_device: "Dispositivo",
  admin_field_message: "Messaggio",
  admin_orgs_title: "Organizzazioni",
  admin_orgs_sub: "Crea, modifica e archivia tenant di E2 Care.",
  admin_orgs_count: "organizzazioni",
  admin_org_new: "Nuova organizzazione",
  admin_org_new_title: "Nuova organizzazione",
  admin_org_edit_title: "Modifica organizzazione",
  admin_org_created: "Organizzazione creata.",
  admin_org_updated: "Organizzazione aggiornata.",
  admin_org_deleted: "Organizzazione archiviata.",
  admin_org_delete_title: "Archiviare l’organizzazione?",
  admin_org_delete_confirm: "«{name}» sarà nascosta dagli elenchi.",
  admin_users_title: "Utenti",
  admin_users_sub_super: "Gestisci ogni account utente su tutti i tenant.",
  admin_users_sub_org: "Gestisci account utenti di {org}.",
  admin_user_new: "Nuovo utente",
  admin_user_new_title: "Nuovo utente",
  admin_user_edit_title: "Modifica utente",
  admin_user_created: "Utente creato.",
  admin_user_updated: "Utente aggiornato.",
  admin_user_deleted: "Utente archiviato.",
  admin_user_delete_title: "Archiviare l’utente?",
  admin_user_delete_confirm: "«{name}» perderà l’accesso.",
  admin_user_memberships: "Appartenenze alle organizzazioni",
  admin_patients_title: "Pazienti",
  admin_patients_sub_super: "Gestisci tutti i pazienti su tutti i tenant.",
  admin_patients_sub_org: "Gestisci pazienti in {org}.",
  admin_patient_new: "Nuovo paziente",
  admin_patient_new_title: "Nuovo paziente",
  admin_patient_edit_title: "Modifica paziente",
  admin_patient_created: "Paziente creato.",
  admin_patient_updated: "Paziente aggiornato.",
  admin_patient_deleted: "Paziente archiviato.",
  admin_patient_delete_title: "Archiviare il paziente?",
  admin_patient_delete_confirm: "«{name}» sarà nascosto dagli elenchi.",
  admin_rooms_title: "Stanze",
  admin_rooms_sub_super: "Configura le stanze su tutti i tenant.",
  admin_rooms_sub_org: "Configura le stanze in {org}.",
  admin_room_new: "Nuova stanza",
  admin_room_new_title: "Nuova stanza",
  admin_room_edit_title: "Modifica stanza",
  admin_room_created: "Stanza creata.",
  admin_room_updated: "Stanza aggiornata.",
  admin_room_deleted: "Stanza archiviata.",
  admin_room_delete_title: "Archiviare la stanza?",
  admin_room_delete_confirm: "«{name}» sarà nascosta.",
  admin_devices_title: "Dispositivi",
  admin_devices_sub_super: "Configura i dispositivi Moko su tutti i tenant.",
  admin_devices_sub_org: "Configura i dispositivi Moko in {org}.",
  admin_device_new: "Nuovo dispositivo",
  admin_device_new_title: "Nuovo dispositivo",
  admin_device_edit_title: "Modifica dispositivo",
  admin_device_created: "Dispositivo creato.",
  admin_device_updated: "Dispositivo aggiornato.",
  admin_device_deleted: "Dispositivo archiviato.",
  admin_device_delete_title: "Archiviare il dispositivo?",
  admin_device_delete_confirm: "Il dispositivo {mac} sarà nascosto.",
  admin_buildings_title: "Edifici",
  admin_buildings_sub_super: "Raggruppa le stanze per edificio / ala su tutti i tenant.",
  admin_buildings_sub_org: "Raggruppa le stanze per edificio / ala in {org}.",
  admin_building_new: "Nuovo edificio",
  admin_building_new_title: "Nuovo edificio",
  admin_building_edit_title: "Modifica edificio",
  admin_building_created: "Edificio creato.",
  admin_building_updated: "Edificio aggiornato.",
  admin_building_deleted: "Edificio archiviato.",
  admin_building_delete_title: "Archiviare l’edificio?",
  admin_building_delete_confirm: "«{name}» sarà nascosto.",
  admin_qa_title: "Strumenti di test",
  admin_qa_sub: "Inietta eventi / avvisi per testare senza hardware Moko reale.",
  admin_qa_event_title: "Inietta evento di test",
  admin_qa_event_sub: "Simula un webhook Moko.",
  admin_qa_alert_title: "Inietta avviso di test",
  admin_qa_alert_sub: "Salta il livello eventi e scrive un avviso direttamente.",
  admin_qa_inject_event: "Inietta evento",
  admin_qa_inject_alert: "Inietta avviso",
  admin_qa_event_done: "Evento iniettato.",
  admin_qa_alert_done: "Avviso iniettato.",
  admin_qa_disclaimer: "Questi endpoint devono essere disabilitati in produzione.",
  admin_alerts_title: "Politica di avvisi",
  admin_alerts_sub: "Regole di avviso per l’intera {org}. Applicate a ogni paziente di questo tenant.",
  admin_alerts_quiet_title: "Ore di silenzio",
  admin_alerts_quiet_desc: "Definisci quando questa organizzazione è in «modalità notte». Utile per instradare gli avvisi non critici in modo più discreto.",
  admin_alerts_quiet_hint: "Gli orari sono interpretati nel fuso orario locale dell’organizzazione. L’intervallo può superare la mezzanotte (es. 22:00 → 06:00).",
  admin_alerts_night_start: "Inizio notte",
  admin_alerts_night_end: "Fine notte",
  admin_alerts_load_failed: "Carica politica di avvisi",
  admin_alerts_save_failed: "Salva politica di avvisi",
  admin_alerts_saved: "Politica di avvisi salvata.",
  admin_alerts_clear_title: "Cancella avvisi attivi",
  admin_alerts_clear_desc: "Conferma tutti gli avvisi aperti di questa organizzazione con un clic.",
  admin_alerts_clear_hint: "Utile dopo un’esercitazione pianificata o un sensore mal configurato che ha prodotto un’ondata di falsi positivi. Gli avvisi confermati restano nella cronologia.",
  admin_alerts_ack_all_button: "Conferma tutti",
  admin_alerts_ack_all_title: "Confermare tutti gli avvisi attivi?",
  admin_alerts_ack_all_confirm: "Ciò contrassegnerà come confermato ogni avviso aperto in {org}. Questa azione non può essere annullata.",
  admin_alerts_ack_all_done: "{count} avviso(i) confermato(i).",
  admin_alerts_ack_all_done_generic: "Tutti gli avvisi attivi confermati.",
  admin_alerts_ack_all_failed: "Conferma tutti gli avvisi",
  org_type_nursing_home: "Casa di riposo",
  org_type_assisted_living: "Residenza assistita",
  org_type_hospital: "Ospedale",
  org_type_home_care: "Assistenza domiciliare",
  role_admin: "Amministratore",
  role_caregiver: "Caregiver",
  role_family: "Famiglia",
  status_active: "attivo",
  status_inactive: "inattivo",
  confirm: "Conferma",
  sign_in: "Accedi",
  signed_in: "Accesso effettuato",
  sign_up: "Registrati",
  email: "E-mail",
  password: "Password",
  full_name: "Nome completo",
  create_account: "Crea account",
  no_account: "Non hai un account?",
  have_account: "Hai già un account?",
  login_welcome: "Bentornato",
  login_sub: "Accedi per continuare a monitorare i tuoi residenti.",
  register_welcome: "Unisciti a E2 Care",
  register_sub: "Crea il tuo spazio di lavoro in meno di un minuto.",
  total_residents: "Pazienti",
  active_devices: "Dispositivi attivi",
  open_alerts: "Avvisi aperti",
  offline_gateways: "Dispositivi offline",
  falls_7d: "Cadute (7g)",
  sos_7d: "SOS (7g)",
  low_battery: "Batteria scarica",
  critical_residents: "Critici",
  status_ok: "Tutto bene",
  status_warning: "Attenzione",
  status_critical: "Critico",
  status_online: "Online",
  status_offline: "Offline",
  search: "Cerca",
  filter: "Filtra",
  all: "Tutti",
  refresh: "Aggiorna",
  loading: "Caricamento…",
  no_results: "Ancora nulla qui.",
  view_profile: "Visualizza profilo",
  showing_n_of_m: "Mostrando {n} di {m}",
  load_more: "Carica altro",
  auto_refresh: "Live · aggiornamento automatico",
  auto_refresh_paused: "In pausa (carica altro attivo)",
  updated_just_now: "Aggiornato ora",
  updated_n_sec_ago: "Aggiornato {n}s fa",
  updated_n_min_ago: "Aggiornato {n}m fa",
  acknowledge: "Conferma",
  acknowledged: "Confermato",
  ack_all: "Conferma tutti",
  ack_all_confirm: "Confermare i {count} avviso(i) attivo(i)?",
  ack_all_running: "Conferma in corso…",
  ack_all_done: "{count} avviso(i) confermato(i).",
  ack_all_partial: "{ok} confermato(i) · {fail} non riuscito(i).",
  last_seen: "Visto l’ultima volta",
  battery: "Batteria",
  signal: "Segnale",
  firmware: "Firmware",
  room: "App. / Stanza",
  age: "Età",
  emergency_contact: "Contatto di emergenza",
  notes: "Note",
  assigned_devices: "Dispositivi assegnati",
  recent_events: "Eventi recenti",
  timeline_24h: "Ultime 24 ore",
  delivery_status: "Stato consegna",
  acknowledged_by: "Confermato da",
  dashboard_title: "Panoramica",
  dashboard_sub: "Una rapida panoramica di tutto ciò che accade nelle case che assisti.",
  residents_title: "Pazienti",
  residents_sub: "Le persone che stai monitorando in questo momento.",
  devices_title: "Dispositivi",
  devices_sub: "Sensori e braccialetti.",
  devices_sub_admin: "Gateway, sensori e braccialetti.",
  events_title: "Eventi live",
  events_sub: "Flusso cronologico da ogni dispositivo connesso.",
  alerts_title: "Avvisi",
  alerts_sub: "Notifiche inoltrate a famiglia e caregiver.",
  settings_title: "Impostazioni",
  settings_sub: "Le tue preferenze e regole di notifica.",
  users_title: "Team",
  users_sub: "Caregiver, famiglia e amministratori con accesso.",
  falls_chart_title: "Cadute & SOS — ultimi 7 giorni",
  recent_alerts_title: "Avvisi critici recenti",
  no_alerts: "Nessun avviso aperto. Tutti sono al sicuro.",
  event_fall: "Caduta rilevata",
  event_sos: "Pulsante SOS premuto",
  event_door_open: "Porta aperta",
  event_door_close: "Porta chiusa",
  event_inactivity: "Inattività prolungata",
  event_low_battery: "Batteria scarica",
  event_offline: "Dispositivo offline",
  event_online: "Dispositivo di nuovo online",
  event_heartbeat: "Battito",
  event_button_press: "Pulsante premuto",
  device_gateway: "Gateway Bluetooth",
  device_door_sensor: "Sensore porta",
  device_bracelet: "Braccialetto",
  device_unknown: "Dispositivo sconosciuto",
  language: "Lingua",
  notifications: "Notifiche",
  quiet_hours: "Ore di silenzio",
  escalation: "Politica di escalation",
  just_now: "proprio ora",
  rel_prefix: "",
  min_ago: "min fa",
  h_ago: "h fa",
  d_ago: "g fa",
  demo_hint: "Account demo: admin@e2care.lv / Care2024!",
  open_menu: "Apri menu",
  close_menu: "Chiudi menu",
  care_team: "Equipe di cura",
  family_members: "Famiglia",
  no_caregivers: "Nessun caregiver assegnato.",
  no_family: "Nessun familiare collegato.",
  add_caregiver: "Aggiungi caregiver",
  add_family: "Aggiungi familiare",
  select_user: "Seleziona un utente…",
  cancel: "Annulla",
  add: "Aggiungi",
  remove: "Rimuovi",
  save: "Salva",
  relationship: "Parentela",
  relationship_son: "Figlio",
  relationship_daughter: "Figlia",
  relationship_spouse: "Coniuge",
  relationship_other: "Altro",
  notify_via: "Notifica tramite",
  call_contact: "Chiama",
  view_resident: "Apri profilo",
  address: "Indirizzo",
  admin_only_section: "Strumenti admin",
  rooms_title: "Stanze",
  rooms_sub: "Ogni stanza che supervisioni — pazienti, dispositivi e stato attuale.",
  room_name: "Stanza",
  room_type: "Tipo",
  room_type_private_room: "Stanza privata",
  room_type_shared_room: "Stanza condivisa",
  room_type_apartment: "Appartamento",
  room_type_corridor: "Corridoio",
  room_type_common_area: "Area comune",
  room_floor: "Piano",
  room_state: "Stato attuale",
  door: "Porta",
  window: "Finestra",
  door_open_state: "Aperta",
  door_closed_state: "Chiusa",
  door_unknown_state: "Sconosciuto",
  room_no_devices: "Ancora nessun dispositivo in questa stanza.",
  room_no_patients: "Ancora nessun paziente assegnato a questa stanza.",
  room_patients: "Pazienti nella stanza",
  room_devices: "Dispositivi nella stanza",
  room_activity: "Cronologia attività",
  rooms_filter_all_types: "Tutti i tipi",
  widget_active_alerts: "Avvisi attivi",
  widget_active_alerts_sub: "Critici, non risolti e confermati",
  widget_patients_status: "Stato pazienti",
  widget_devices_health: "Stato dispositivi",
  widget_room_activity: "Attività stanze",
  widget_recent_events: "Feed eventi live",
  widget_connectivity: "Connettività",
  metric_critical: "Critico",
  metric_unresolved: "Non risolto",
  metric_acknowledged_count: "Confermati",
  metric_total: "Totale",
  metric_active: "Attivi",
  metric_online: "Online",
  metric_offline: "Offline",
  metric_ota_pending: "OTA in attesa",
  metric_battery_warn: "Batteria scarica",
  metric_doors_open: "Porte aperte",
  metric_windows_open: "Finestre aperte",
  metric_signal_avg: "Segnale medio",
  metric_last_comm: "Ultima com.",
  metric_packets: "Pacchetti / h",
  view_all: "Vedi tutto",
  status_new: "Nuovo",
  status_acknowledged: "Confermato",
  status_resolved: "Risolto",
  status_resolved_local: "Risolto (locale)",
  resolve: "Risolvi",
  add_note: "Aggiungi nota",
  save_note: "Salva nota",
  resolve_local_badge: "solo questo dispositivo",
  resolve_local_hint: "Contrassegna l’avviso come risolto solo nel tuo browser. Il server e gli altri membri del team lo vedono ancora come aperto.",
  note_placeholder: "Aggiungi contesto per il team…",
  notes_count: "{n} nota/e",
  device_detail: "Dettagli dispositivo",
  device_diagnostics: "Diagnostica",
  device_firmware_history: "Cronologia firmware",
  device_ota_config: "Configurazione OTA",
  device_ota_status: "Stato OTA",
  device_signal: "Qualità segnale",
  device_mac: "Indirizzo MAC",
  device_serial: "Numero di serie",
  fall_sensitivity: "Sensibilità caduta",
  transmission_interval: "Intervallo di trasmissione",
  low_battery_threshold: "Soglia batteria scarica",
  ota_idle: "Inattivo",
  ota_pending: "In attesa",
  ota_deploying: "In distribuzione",
  ota_failed: "Fallito",
  events_filter_severity: "Gravità",
  events_filter_room: "Stanza",
  events_filter_patient: "Paziente",
  events_filter_device: "Dispositivo",
  severity_info: "Info",
  severity_warning: "Avvertimento",
  severity_critical: "Critico",
  telegram_title: "Avvisi Telegram",
  telegram_desc: "Ricevi avvisi Telegram per i residenti a cui sei assegnato.",
  telegram_connect: "Collega Telegram",
  telegram_connected: "Telegram collegato",
  telegram_connected_as: "Collegato a Telegram come {name}",
  telegram_connect_success: "Telegram collegato con successo",
  telegram_connect_error: "Impossibile collegare Telegram. Riprova.",
  telegram_missing_bot: "Bot Telegram non configurato. Imposta REACT_APP_TELEGRAM_BOT nel file env.",
  telegram_disconnect: "Disconnetti",
  telegram_disconnect_success: "Telegram disconnesso.",
  telegram_disconnect_error: "Impossibile disconnettere Telegram. Riprova.",
  telegram_already_linked: "Questo account Telegram è già collegato a un altro utente e2-care.",
  telegram_switch_q: "Usare un altro account Telegram?",
  telegram_switch_intro: "Telegram ricorda quale account è connesso su tutti i siti web. Per usarne un altro:",
  telegram_switch_step1: "Apri Telegram Web ed esci dal tuo account attuale.",
  telegram_switch_step2: "Torna qui e ricarica il pulsante qui sotto, poi accedi con l’altro account.",
  telegram_open_web: "Apri Telegram Web",
  telegram_reload_widget: "Ho effettuato la disconnessione — ricarica il pulsante",
  lang_autodetected_toast: "Lingua rilevata: {language}. Puoi cambiarla nelle Impostazioni.",
  admin_view_active: "Attivi",
  admin_view_archived: "Archiviati",
  admin_restore: "Ripristina",
  admin_restored: "Ripristinato.",
  admin_hard_delete: "Elimina definitivamente",
  admin_hard_delete_title: "Eliminare definitivamente?",
  admin_hard_delete_confirm: "«{name}» sarà eliminato definitivamente dal database. L’azione non può essere annullata.",
  admin_hard_deleted: "Eliminato definitivamente.",
  admin_no_archived: "Nessun elemento archiviato.",
  language_desc: "Usata per l’interfaccia dell’app e per le tue notifiche Telegram + push.",
  language_saved: "Lingua aggiornata.",
  language_error: "Impossibile aggiornare la lingua. Riprova.",
  admin_field_language: "Lingua",
  edit: "Modifica",
  generic_error: "Qualcosa è andato storto. Riprova.",
  caregiver_added: "Assistente aggiunto.",
  caregiver_removed: "Assistente rimosso.",
  family_added: "Familiare aggiunto.",
  family_removed: "Familiare rimosso.",
  menu: "Menu",
  dl_companion_app: "App companion",
  dl_hero_title: "E2 Care per Android",
  dl_hero_sub: "Installa l’app companion su un telefono dotato di Moko per inoltrare gli avvisi, configurare i dispositivi e restare connesso al tuo team di assistenza, anche quando la dashboard è chiusa.",
  dl_android_apk: "APK Android",
  dl_version_loading: "caricamento versione…",
  dl_released: "Rilasciato il {date}",
  dl_download_apk: "Scarica APK",
  dl_unavailable: "Non disponibile",
  dl_preparing: "Preparazione…",
  dl_manifest_error: "Impossibile caricare il manifest. Prova ad aggiornare; se il problema persiste, il server di build potrebbe essere in fase di redistribuzione.",
  dl_whats_new: "Novità",
  dl_installing_title: "Installazione sul telefono",
  dl_step1: "Tocca «Scarica APK» qui sopra. Il browser potrebbe avvisare che i file APK possono danneggiare il dispositivo: è un avviso normale per qualsiasi installer scaricato al di fuori del Play Store.",
  dl_step2: "Apri il file scaricato. Android ti chiederà di consentire le installazioni da questo browser la prima volta: attiva l’autorizzazione e torna indietro.",
  dl_step3: "Tocca «Installa», poi «Apri» al termine.",
  dl_step4: "Accedi con le tue credenziali E2 Care.",
  dl_iphone_note: "La versione per iPhone arriverà più avanti. Per ora, usa la dashboard web.",
  dl_back_to_dashboard: "Torna alla dashboard",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Cambiare organizzazione azzera l’assegnazione corrente di stanza e paziente.",
  admin_view_full: "Elenco completo",
  device_filter_assignment: "Assegnazione",
  device_filter_patient: "Assegnato a paziente",
  device_filter_room: "Assegnato a stanza",
  device_filter_unassigned: "Non assegnato",
  admin_all_orgs: "Tutte le organizzazioni",
  pagination_prev: "Precedente",
  pagination_next: "Successivo",
  pagination_per_page: "Per pagina",
  pagination_page_of: "Pagina {page} di {pages}",
  pagination_total: "{total} in totale",
  event_charging: "Ricarica avviata",
  event_sos_cancel: "SOS annullato",
  event_call: "Chiamata SOS",
  device_personal_alarm: "Allarme personale",
  device_charging: "In carica",
  device_location: "Posizione",
  device_current_location: "Posizione attuale",
  device_no_location: "Nessuna posizione segnalata finora.",
  device_location_source: "Fonte",
  device_location_updated: "Aggiornato",
  device_track_1h: "1h",
  device_track_24h: "24h",
  device_track_7d: "7g",
  device_track_last: "Ultima posizione",
  device_located: "Localizzato",
  map_sos: "Allarme SOS",
  map_fall: "Caduta rilevata",
  map_current: "Posizione attuale",
  alert_timeline: "Cronologia dell'allarme",
  alert_trigger: "Attivazione",
  alert_calls: "Chiamate",
  alert_view_timeline: "Vedi cronologia",
  alert_no_deliveries: "Nessuna notifica inviata finora.",
  alert_cancelled_on_device: "L'SOS è stato annullato sul dispositivo: l'allarme resta aperto finché un operatore non lo risolve.",
  call_answered: "Risposta",
  call_missed: "Persa",
  reopen: "Riapri",
  reopened: "Allarme riaperto",
  live: "In diretta",
  nav_home: "Home",
  family_home_kicker: "Vista famiglia",
  family_home_title: "I tuoi cari",
  family_greeting: "Ciao",
  family_home_sub: "Una panoramica serena di come sta ognuno.",
  family_status_ok: "sta bene",
  family_status_attention: "richiede attenzione",
  family_all_calm: "Tutto tranquillo al momento.",
  family_attention_sub: "Vediamo come sta — dettagli qui sotto.",
  family_last_seen: "visto l'ultima volta",
  family_latest_alert: "Ultimo allarme",
  family_no_alerts: "Nessun allarme recente — va tutto bene.",
  family_view_details: "Vedi dettagli",
  family_no_device: "Nessun allarme personale ancora collegato.",
  status_never_reported: "Mai segnalato",
  mv_title: "Movimento",
  mv_sub: "Da {n} sensore/i di movimento · finestre di 5 minuti",
  mvo_title: "Movimento a colpo d'occhio",
  mvs_moving: "{name} è in piedi e in movimento",
  mvs_moving_sub: "Movimento {when}",
  mvs_rest: "{name} sta riposando",
  mvs_rest_sub: "Ultimo movimento {when}",
  mvs_rest_sub_none: "Nessun movimento negli ultimi 30 giorni",
  mvs_quiet: "{name} non si muove da più tempo del solito",
  mvs_quiet_sub: "Nessun movimento da {dur}. Una breve chiamata potrebbe essere utile.",
  mvs_short_quiet: "Fermo a lungo",
  mvs_room_moving: "Qualcuno si muove in {name}",
  mvs_room_rest: "{name} è tranquilla",
  mvs_room_quiet: "Nessun movimento in {name} da più tempo del solito",
  mvs_sensor: "Il sensore di movimento non trasmette",
  mvs_sensor_sub: "Riguarda il sensore, non {name}. Ultimo segnale {when}.",
  mvs_nodata: "Ancora nessun dato di movimento",
  mvs_nodata_sub: "Il sensore di movimento non ha ancora inviato nulla.",
  mvd_title: "Ultime 24 ore",
  mvd_moving: "In movimento",
  mvd_resting: "A riposo",
  mvd_nosignal: "Nessun segnale",
  mvd_night: "Notte",
  mvd_now: "Ora",
  mvn_title: "Ultime 7 notti",
  mvn_last_night: "Stanotte",
  mvn_last_short: "Ieri",
  mvn_calm: "Tranquilla",
  mvn_restless: "Agitata",
  mvn_still: "Molto ferma",
  mvn_silent: "Sensore muto",
  mvn_nodata: "Nessun dato",
  mvn_s_calm_none: "Notte tranquilla, nessun movimento tra le {from} e le {to}.",
  mvn_s_calm_once: "Notte tranquilla, un risveglio verso le {at}.",
  mvn_s_calm_many: "Notte tranquilla, {n} risvegli, il primo verso le {first}, l'ultimo verso le {last}.",
  mvn_s_restless: "Notte agitata, {n} risvegli tra le {first} e le {last}.",
  mvn_s_still: "Notte molto ferma, meno movimento del solito. Riposo più lungo {dur}.",
  mvn_s_still_moved: "Notte molto ferma, movimento solo verso le {at}. Riposo più lungo {dur}.",
  mvn_s_silent: "Il sensore è rimasto quasi muto, quindi non sappiamo com'è andata la notte.",
  mvn_s_nodata: "Nessun dato di movimento per questa notte.",
  mv_state_moving: "In movimento",
  mv_state_still: "A riposo",
  mv_state_inactive: "Inattivo",
  mv_state_silent: "Sensore non trasmette",
  mv_state_never: "Mai segnalato",
  mv_state_nodata: "Ancora nessun dato",
  mv_state_no_sensor: "Nessun sensore di movimento",
  mv_last_movement: "Ultimo movimento",
  mv_last_sample: "Ultimo segnale del sensore",
  mv_none_in_retention: "Nessuno negli ultimi 30 giorni",
  mv_silent_hint: "Nessun campione da oltre {min} min: controllare il sensore o il suo gateway. È un guasto del dispositivo, non immobilità.",
  mv_inactive_hint: "Nessun movimento da oltre {min} min mentre il sensore continua a trasmettere.",
  mv_history: "Storico movimenti",
  mv_history_empty: "Ancora nessun dato di movimento in questo intervallo.",
  mv_not_reporting: "Non trasmette",
  mv_no_movement: "Nessun movimento",
  mv_detections: "rilevamenti di movimento",
  mv_legend_motion: "Rilevamenti di movimento",
  mv_legend_gap: "Non trasmette",
  mv_retention_note: "Storico conservato 30 giorni",
  mv_strip_title: "Movimento in tempo reale",
  mv_strip_sub: "{n} sensore/i di movimento",
  mv_unassigned: "Sensore non assegnato",
  admin_alerts_timezone: "Fuso orario dell'organizzazione",
  admin_alerts_timezone_invalid: "Scegli un fuso orario IANA valido.",
  admin_alerts_night_wrap_hint: "Le ore notturne vanno dalle {start} alle {end} del mattino seguente ({tz}), cioè dopo le {start} o prima delle {end}.",
  admin_alerts_night_same_day_hint: "Le ore notturne vanno dalle {start} alle {end} dello stesso giorno ({tz}).",
  admin_alerts_night_equal: "Inizio e fine non possono coincidere.",
  admin_alerts_inactivity_label: "Soglia di inattività",
  admin_alerts_inactivity_question: "Questa persona si è mossa? Minuti senza movimento prima che diventi motivo di allerta.",
  admin_alerts_silence_label: "Soglia di silenzio del dispositivo",
  admin_alerts_silence_question: "Questo sensore comunica ancora? Minuti senza alcun campione prima di considerarlo un guasto del dispositivo e non un residente inattivo.",
  admin_alerts_minutes: "minuti",
  admin_alerts_threshold_invalid: "Inserisci un numero intero maggiore di 0.",
  admin_alerts_thresholds_provisional: "I valori iniziali (180 / 30 min) non sono ancora stati calibrati: adattali ai tuoi residenti.",
  admin_tab_gateways: "Gateway",
  gw_title: "Gateway",
  gw_status_deactivated: "Disattivato",
  gw_scope_pending: "I gateway della tua organizzazione appariranno qui quando l'aggiornamento del backend sarà attivo.",
  gw_none_for_org: "Nessun gateway ancora assegnato a questa organizzazione.",
  gw_col_room: "Stanza",
  gw_unassigned: "Non assegnato",
  gw_never: "Mai",
  gw_edit_title: "Modifica gateway",
  gw_new_title: "Nuovo gateway",
  gw_super_field: "Solo un super-admin può modificarlo",
  gw_mac_invalid: "Inserisci 12 caratteri esadecimali, es. AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Tipo di hardware",
  gw_notes: "Note",
  gw_manage_sub: "Hub BLE che inoltrano i sensori: stato, organizzazione e stanza. Un gateway muto rende muti tutti i sensori dietro di lui.",
  gw_filter_all: "Tutte le organizzazioni",
  gw_new: "Nuovo gateway",
  gw_col_assignment: "Organizzazione · Stanza",
  gw_backend_pending: "Serve l'aggiornamento del backend, non ancora distribuito.",
  gw_save_failed: "Salva gateway",
  gw_created: "Gateway creato",
  gw_saved: "Gateway salvato",
  gw_reactivated: "Gateway riattivato",
  gw_deactivated: "Gateway disattivato",
  gw_reactivate: "Riattiva",
  gw_deactivate: "Disattiva",
  gw_reactivate_title: "Riattivare {name}?",
  gw_deactivate_title: "Disattivare {name}?",
  gw_reactivate_desc: "Tornerà a contare nello stato e negli avvisi.",
  gw_deactivate_desc: "Smette di contare nello stato e negli avvisi. La cronologia resta e puoi riattivarlo in qualsiasi momento.",
  gw_heard_title: "Dispositivi che sente",
  gw_heard_sub: "Sensori inoltrati da questo gateway nelle ultime 24 ore.",
  gw_heard_none: "Nessun dispositivo nelle ultime 24 ore.",
  gw_heard_unknown: "Dispositivi sconosciuti",
  gw_msgs_short: "msg",
  gw_avg: "media",
  gw_samples_short: "campioni",
  gw_not_found: "Gateway non trovato o non visibile.",
  gw_one: "Gateway",
  gw_manage_link: "Gestisci in Amministrazione",
  gw_rssi_range: "Intervallo segnale",
  gw_longest_gap: "Interruzione più lunga",
  gw_config_push: "Ultimo invio config",
  gw_sub: "Hub BLE che inoltrano i dati dei sensori. Sola lettura: un gateway silenzioso fa sembrare silenziosi tutti i sensori collegati.",
  gw_super_only: "Lo stato dei gateway è disponibile solo per i super-amministratori.",
  gw_load_failed: "Caricamento gateway",
  gw_status_reporting: "Trasmette",
  gw_status_silent: "Silenzioso",
  gw_status_never_seen: "Mai visto",
  gw_returned: "Tornato dopo {h} h di assenza (terminata {at})",
  gw_count_reporting: "{n} trasmettono",
  gw_count_silent: "{n} silenziosi",
  gw_count_never: "{n} mai visti",
  gw_count_deactivated: "{n} disattivato/i",
  gw_window: "Obsoleto dopo {h} h senza messaggi",
  gw_col_name: "Gateway",
  gw_col_status: "Stato",
  gw_col_msgs: "Messaggi 24 h",
  gw_col_discard: "Scartati",
  gw_last_message: "Ultimo messaggio",
  gw_devices_seen: "Dispositivi visti",
  gw_hours_active: "Ore attive",
  gw_unregistered_title: "Trasmette senza registrazione",
  gw_unregistered_desc: "Questi identificativi compaiono nell'attività dei gateway ma non hanno una scheda (es. un'unità che trasmette con un IMEI). I totali delle due fonti possono legittimamente differire.",
  nav_reports: "Report",
  rep_night_title: "Riepilogo notturno",
  rep_night_desc: "Riepilogo mattutino del movimento di ogni residente durante le ore notturne dell'organizzazione e dei silenzi dei sensori.",
  rep_last_night: "Ieri notte",
  rep_nights_ago: "{n} notti fa",
  rep_policy_fallback: "ore notturne predefinite (policy non disponibile)",
  rep_movement: "Movimento",
  rep_windows: "{n} finestre di 5 min attive",
  rep_no_movement: "Nessun movimento",
  rep_first_movement: "Primo movimento",
  rep_longest_still: "Immobilità più lunga",
  rep_silences: "Silenzi del sensore",
  rep_none: "Nessuno",
  rep_coverage: "{pct}% ricevuto",
  rep_night_note: "Gli orari sono nel fuso dell'organizzazione. L'immobilità è contata solo mentre il sensore trasmette; i silenzi pari o superiori alla soglia di silenzio sono elencati a parte.",
  dh_reporting_title: "Stato di trasmissione",
  dh_never_reported_desc: "Registrato ma non ha mai trasmesso. È un'installazione incompleta, non un dispositivo offline.",
  dh_interval_still: "Intervallo misurato (fermo)",
  dh_interval_moving: "Intervallo misurato (in movimento)",
  dh_interval_samples: "Campioni di misura",
  dh_interval_unmeasured: "Nessun intervallo misurato: si applica la soglia di silenzio dell'organizzazione.",
  dh_interval_note: "Gli intervalli sono misurati dai messaggi ricevuti, non dal valore configurato.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Stanza condivisa: può includere il movimento di altri",
  rep_no_data_night: "Nessun dato per questa notte: il sensore non trasmetteva (o non era ancora installato).",
  nav_buildings: "Edifici",
  imei_label: "IMEI",
  imei_hint: "15 cifre, stampate sul retro del dispositivo",
  imei_length: "L'IMEI ha 15 cifre",
  imei_invalid: "Questo IMEI non è valido. Controlla le cifre",
  imei_resident_note: "L'allarme segue il residente, quindi non è assegnato a una stanza.",
  imei_online_hint: "Il dispositivo risulta online dopo il primo segnale di vita, circa 5 minuti dopo l'accensione.",
  forgot_link: "Password dimenticata? Clicca qui",
  forgot_title: "Reimposta la password",
  forgot_sub: "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
  forgot_submit: "Invia link",
  forgot_sent: "Se esiste un account per questa email, abbiamo inviato un link per reimpostare la password. Controlla la posta.",
  forgot_back: "← Torna all'accesso",
  reset_title: "Imposta una nuova password",
  reset_sub: "Scegli una nuova password per il tuo account.",
  reset_new_password: "Nuova password",
  reset_confirm_password: "Conferma password",
  reset_hint: "Almeno 8 caratteri.",
  reset_submit: "Aggiorna password",
  reset_success: "Password aggiornata. Reindirizzamento all'accesso…",
  reset_too_short: "La password deve avere almeno 8 caratteri.",
  reset_mismatch: "Le password non coincidono.",
  reset_no_token: "Questo link non è valido o manca. Richiedine uno nuovo dalla pagina di accesso.",
  reset_failed: "Questo link non è valido o è scaduto. Richiedine uno nuovo.",
  admin_tab_device_types: "Tipi di dispositivo",
  admin_dt_title: "Tipi di dispositivo",
  admin_dt_sub: "Il catalogo dei modelli. Rinomina l'etichetta di un tipo: chiave interna, mappatura IoT e sincronizzazione restano invariate.",
  admin_dt_col_label: "Etichetta",
  admin_dt_col_key: "Chiave interna",
  admin_dt_col_category: "Categoria",
  admin_dt_col_wearable: "Indossabile",
  admin_dt_col_ble_sync: "Sincronizzazione BLE",
  admin_dt_col_ble_type_id: "ID tipo BLE",
  admin_dt_wearable_yes: "Indossato dal residente",
  admin_dt_wearable_no: "Fisso",
  admin_dt_ble_sync_on: "Richiesta",
  admin_dt_ble_sync_off: "Disattiva",
  admin_dt_edit_label: "Modifica etichetta",
  admin_dt_edit_title: "Rinomina etichetta",
  admin_dt_edit_desc: "Cambia solo l'etichetta leggibile. Dispositivi, filtri e integrazioni continuano a usare la chiave interna «{key}».",
  admin_dt_label_saved: "Etichetta aggiornata.",
  admin_dt_label_required: "L'etichetta non può essere vuota.",
  admin_dt_load_failed: "Caricamento tipi di dispositivo",
  admin_dt_save_failed: "Aggiornamento etichetta",
  admin_dt_readonly_hint: "Solo i super-amministratori possono rinominare le etichette.",
  sensor_climate: "Clima",
  sensor_temperature: "Temperatura",
  sensor_humidity: "Umidità",
  sensor_last_reading: "Ultima lettura",
  sensor_history_title: "Temperatura e umidità (48 h)",
  sensor_history_empty_title: "Ancora nessuna lettura",
  sensor_history_empty_sub: "Assegna un sensore H4 Pro a questa stanza per vedere lo storico climatico.",
  admin_thresholds_title: "Soglie dei sensori",
  admin_thresholds_desc: "Limiti di allerta di temperatura e umidità per i sensori H4 Pro di questa organizzazione.",
  admin_thresholds_temp_min: "Temperatura min",
  admin_thresholds_temp_max: "Temperatura max",
  admin_thresholds_hum_min: "Umidità min",
  admin_thresholds_hum_max: "Umidità max",
  admin_thresholds_temp_invalid: "La temperatura minima deve essere inferiore alla massima.",
  admin_thresholds_hum_invalid: "L'umidità minima deve essere inferiore alla massima.",
  admin_thresholds_hint: "Tutti e quattro sono facoltativi: lascia vuoto un campo per non avere allerte su quel limite.",
  admin_thresholds_cooldown: "Intervallo tra allerte",
  admin_thresholds_cooldown_placeholder: "Predefinito: 30 min",
  admin_thresholds_cooldown_help: "Minuti tra allerte ripetute del sensore. Lascia vuoto per il valore di sistema (30 min).",
  admin_thresholds_cooldown_invalid: "L'intervallo deve essere un numero intero di almeno 1 minuto.",
  admin_thresholds_saved: "Soglie salvate.",
  admin_thresholds_load_failed: "Caricamento soglie",
  admin_thresholds_save_failed: "Salvataggio soglie",
  room_activity_view_all: "Vedi tutti gli eventi",
  role_super_admin: "Super amministratore",
  assign_device: "Assegna dispositivo",
  select_device: "Seleziona un dispositivo…",
  admin_patient_no_devices_assigned: "Nessun dispositivo assegnato.",
  admin_patient_no_wearables: "Nessun dispositivo indossabile disponibile in questa organizzazione.",
  admin_patient_device_reassign: "riassegna",
  recent_critical_alerts_title: "Allerte critiche recenti",
  rooms_building_clear: "Rimuovi filtro",
  buildings_title: "Edifici",
  buildings_sub: "Ogni edificio che supervisioni, con stanze, residenti e dispositivi.",
  buildings_view_rooms: "Vedi stanze",
  wt_title: "Andamento settimanale",
  wt_desc: "Sette notti affiancate per residente — o per stanza condivisa — per individuare notti agitate o insolitamente immobili.",
  wt_baseline_note: "ogni notte è confrontata con la mediana di 7 notti della riga",
  wt_no_sensors: "Nessun residente ha ancora un sensore di movimento.",
  wt_flag_restless: "Agitata",
  wt_flag_still: "Insolitamente immobile",
  wt_flag_nodata: "Nessun dato",
  wt_flag_silent: "Sensore quasi muto",
  rep_sensor_silent: "Il sensore ha trasmesso solo per il {pct}% di questa notte. I vuoti indicano che il sensore ha smesso di trasmettere, non che l'ospite fosse immobile.",
  wt_legend_active: "Finestre di 5 min attive",
  wt_legend_still: "Immobilità più lunga (h)",
  fap_title: "I familiari possono gestire gli avvisi",
  fap_desc: "Se attivo, i familiari possono confermare, risolvere, riaprire e annotare gli avvisi dei propri ospiti in {org}.",
  note_saved: "Nota salvata",
  event_device_silent: "Sensore muto",
  event_no_movement: "Nessun movimento",
  event_no_rise: "Nessun movimento dopo la notte",

  dur_lt_min: "meno di un minuto",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Caduta rilevata",
  am_sos: "Pulsante SOS premuto",
  am_low_battery: "Batteria del dispositivo scarica",
  am_low_battery_dev: "Batteria scarica su {device}",
  am_door: "Porta aperta",
  am_door_in: "Porta aperta in {place}",
  am_door_in_detail: "Porta aperta in {place} ({detail})",
  am_window: "Finestra aperta",
  am_window_in: "Finestra aperta in {place}",
  am_window_in_detail: "Finestra aperta in {place} ({detail})",
  am_silent: "Il sensore di movimento in {place} non trasmette da circa {dur}: controlla l'alimentazione o il gateway",
  am_silent_nodur: "Il sensore di movimento in {place} non trasmette più: controlla l'alimentazione o il gateway",
  am_nomove: "Nessun movimento rilevato in {place} da circa {dur}",
  am_nomove_nodur: "Nessun movimento rilevato in {place}",
  am_norise: "Nessun movimento rilevato in {place} dalla fine della notte (di solito in piedi entro le {time})",
  am_norise_notime: "Nessun movimento rilevato in {place} dalla fine della notte",
  amf_silent_res: "Il sensore di movimento di {name} non trasmette dalle {time}, quindi al momento il movimento non viene seguito.",
  amf_silent_room: "Il sensore di movimento in {place} non trasmette dalle {time}, quindi al momento lì il movimento non viene seguito.",
  amf_sensor_ok: "Il sensore funziona; semplicemente non ha visto nessuno muoversi.",
  amf_team: "Il team di cura è stato avvisato sul proprio pannello.",
  amf_contact_device: "Sei indicato come contatto per questo dispositivo.",
  amf_contact_resident: "Sei indicato come contatto per {name}.",
  al_tab_care: "Cura",
  al_tab_maint: "Manutenzione",
  al_maint_hint: "Sensori che non trasmettono e batterie scariche: lavoro tecnico, non eventi di cura.",
  al_maint_empty: "Nessun problema di sensori o batterie.",
  al_auto_closed: "Chiuso automaticamente",
  al_auto_closed_reason: "Chiuso automaticamente — {reason}",
  al_never_seen: "nessuno l'ha visto prima della chiusura",
  al_resolved_by: "Risolto da {name}",
  al_reason_movement: "il movimento è ripreso",
  al_reason_sensor: "il sensore trasmette di nuovo",
  al_admin_only_ack: "Solo un amministratore può gestire questo avviso, perché non è legato a un singolo ospite.",
  why_title: "Perché è scattato?",
  why_since_motion: "Dall'ultimo movimento",
  why_since_sample: "Dall'ultima trasmissione del sensore",
  why_threshold: "Soglia",
  why_up_by: "Di solito in piedi entro le",
  why_night: "Fascia notturna",
  why_source: "Soglia impostata da",
  why_src_org: "questa organizzazione",
  why_src_default: "valori predefiniti",
  why_state: "Stato del sensore",
  why_checked: "Controllato alle",
  why_approx: "I controlli avvengono ogni 5 minuti, quindi gli orari degli avvisi sono approssimativi.",
  mon_label: "Monitoraggio del movimento",
  mon_active: "attivo",
  mon_down: "non trasmette",
  mon_down_since: "non trasmette dalle {time}",
  admin_alerts_up_by_label: "Di solito in piedi entro le",
  admin_alerts_up_by_question: "Se non si vede movimento tra la fine della notte e quest'ora, viene creato un avviso «nessun movimento dalla fine della notte».",
  admin_alerts_up_by_invalid: "Deve essere dopo la fine della notte ({end}): è l'ora in cui gli ospiti sono di solito in piedi, a notte finita.",
  admin_alerts_up_by_format: "Inserisci un orario come HH:MM.",
  admin_alerts_escalation_label: "Avvisa la famiglia di un sensore muto dopo",
  admin_alerts_escalation_question: "Il personale vede subito un sensore muto. La famiglia viene avvisata solo se non è ancora risolto dopo questo tempo (subito se l'organizzazione non ha operatori).",
  admin_alerts_cooldown_note: "Quando un avviso si chiude, lo stesso avviso può tornare quando la soglia viene superata di nuovo. L'avviso del mattino scatta al massimo una volta al giorno.",
  admin_alerts_stored_invalid: "L'orario salvato ({up}) non è dopo la fine della notte ({end}): gli avvisi del mattino non possono funzionare e questa politica non può essere salvata finché non viene corretta.",
  admin_alerts_defaults_badge: "Valori predefiniti",

  fap_auto_on: "Automatico: attivo, perché questa organizzazione non ha operatori.",
  fap_auto_off: "Automatico: disattivo, perché questa organizzazione ha operatori.",
  fap_manual: "Impostato da un amministratore.",
  fap_reset: "Torna ad automatico",
  fap_saved: "Salvato",
  fap_save_failed: "Impossibile salvare. Riprova.",
  fap_pending: "Presto disponibile",
  fap_retry: "Riprova",
  recap_title: "Riepilogo mattutino della notte",
  recap_desc_staff: "Ogni giorno alle 07:00 (ora dell'organizzazione), un riepilogo della notte di ogni residente della tua organizzazione.",
  recap_desc_family: "Ogni giorno alle 07:00 (ora dell'organizzazione), un riepilogo della notte dei tuoi cari.",
  recap_on: "Attivo",
  recap_off: "Disattivo",
  recap_email: "Email",
  recap_telegram_link_first: "Collega Telegram qui sopra per riceverlo lì.",
  recap_no_channel: "Scegli almeno un canale, altrimenti non verrà inviato nulla.",
  recap_last_sent: "Ultimo invio {at}",
  recap_saved: "Preferenze salvate.",
  recap_save_failed: "Impossibile salvare le preferenze.",
  recap_unavailable: "Prossimamente",
  topbar_org_label: "Organizzazione",
  device_ota_phase2: "Il deployment OTA diventerà interattivo nella fase 2.",
  event_window_open: "Finestra aperta",
  event_window_close: "Finestra chiusa",
  event_alarm_end: "Fine allarme",
  wt_h: "h",
  wt_load_failed: "Impossibile caricare lo storico movimenti. Riprova più tardi.",
  recap_load_failed: "Impossibile caricare le preferenze: tocca per riprovare.",
  mv_shared_note: "Questo residente condivide la stanza. Un sensore di stanza non distingue i residenti, quindi il movimento è mostrato per la stanza, non per una persona.",
  mv_shared_link: "Vedi il movimento di {room}",
  mv_room_shared_note: "Condivisa da {n} residenti: questo movimento non può essere attribuito a nessuno di loro.",
  rep_shared_room_row: "Stanza condivisa · {names}",
  admin_motion_resident: "Sensore da comodino di un residente",
  admin_motion_resident_hint: "Facoltativo. Scegli un residente solo se questo sensore osserva il suo spazio personale (es. rivolto al letto). I suoi grafici di movimento lo useranno, anche in stanza condivisa.",
  admin_motion_whole_room: "Tutta la stanza",
};
export default it;
